<template>
  <div>
    <cx-check-box :value.sync="emptyDataShowLocal">
      <span>数据为空时显示以下图片</span>
      <el-tooltip popper-class="width200" effect="dark" content="勾选后，数据源为空时，图片组件显示你所配置的内容，未勾选，数据源为空时，图片组件显示默认图片样式"
        placement="top" :open-delay="1000">
        <span class="tips-btn icon-portal-info2"></span>
      </el-tooltip>
    </cx-check-box>
    <div v-if="emptyDataShowLocal" class="mt12">
      <img-upload :imgSrc.sync="emptyImgSrc" imgType="12" :defaultImg="defaultImgBg" :iconColor.sync="iconColor"
        :showDel="false" :showSize="false" size="medium"></img-upload>
    </div>
  </div>
</template>
<script>
import defaultImgBg from "assets/images/empty_img_bg.png"
export default {
  name: "emptyDataShow",
  props: {
    options: {
      type: Object
    }
  },
  data() {
    return {
      this1: this,
      defaultImgBg: defaultImgBg,
    }
  },
  computed: {
    emptyDataShowLocal: {
      get() {
        return this.options.hasOwnProperty("emptyDataShowLocal") ? this.options.emptyDataShowLocal : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "emptyDataShowLocal", false, null)
      }
    },
    emptyImgSrc: {
      get() {
        return this.options.emptyImgSrc || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "emptyImgSrc", false)
      }
    },
    iconColor: {
      get() {
        return this.options.iconColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "iconColor", false)
      }
    },
  }
}
</script>